function decodeChallenge(challenge: string) {
  // Replace URL-safe Base64 characters with standard Base64 characters
  let base64String = challenge
    .replace(/-/g, "+") // Replace '-' with '+'
    .replace(/_/g, "/") // Replace '_' with '/'

  // Add padding if necessary
  const padding = base64String.length % 4
  if (padding) {
    const pad = "=".repeat(4 - padding)
    base64String += pad
  }

  // Now you can decode it using atob
  return Uint8Array.from(atob(base64String), (c) => c.charCodeAt(0))
}

function decodeUserId(userId: string) {
  // Step 1: Decode the Base64 string
  const decodedString = atob(userId.replace(/_/g, "/").replace(/-/g, "+")) // Adjust URL-safe Base64 encoding

  // Step 2: Convert the decoded string to an ArrayBuffer
  const buffer = new ArrayBuffer(decodedString.length)
  const view = new Uint8Array(buffer)
  for (let i = 0; i < decodedString.length; i++) {
    view[i] = decodedString.charCodeAt(i)
  }
  return buffer
}

function base64UrlEncode(buffer: any) {
  // @ts-ignore
  const binary = String.fromCharCode(...new Uint8Array(buffer))
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

function hashString(input: string) {
  const encoder = new TextEncoder()
  const data = encoder.encode(input)

  return crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
    // Convert the hash buffer into a Base64 string
    const base64String = btoa(
      Array.from(new Uint8Array(hashBuffer))
        .map((byte) => String.fromCharCode(byte))
        .join(""),
    )
    return base64String
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "")
  })
}

function generateDeviceID(userID: string) {
  const navigatorInfo = [
    navigator.userAgent,
    navigator.language,
    navigator.hardwareConcurrency,
  ].join(" ")

  const screenInfo = [screen.width, screen.height, screen.colorDepth].join("x")
  const rawData = `${navigatorInfo}|${userID}|${screenInfo}`
  return hashString(rawData)
}

async function getOrCreateDeviceID(userID: string | null) {
  const storageKey = "deviceID"

  let deviceID = localStorage.getItem(storageKey)

  if (!deviceID && userID) {
    // @ts-ignore
    deviceID = await generateDeviceID(userID)
    localStorage.setItem(storageKey, deviceID)
  }
  return deviceID
}

export {
  decodeChallenge,
  decodeUserId,
  base64UrlEncode,
  generateDeviceID,
  getOrCreateDeviceID,
  hashString,
}
